import type { TFunction } from 'i18next';
import { secondaryBase } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import type { ExtendedComboboxItem } from '../../../../../ui-library/select/select.type';
import { StrategyTab } from '../../../strategy.type';
import { ThroughputMode } from '../../initiative-performance.type';

/**
 * Returns a list of options for the throughput mode dropdown
 *
 * @param {StrategyTab} currentStrategyTab - The currently active strategy tab
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns {ExtendedComboboxItem[]} Array of options for the throughput mode selection
 */
const getThroughputModeOptions = (currentStrategyTab: StrategyTab, t: TFunction): ExtendedComboboxItem[] => {
  const options = [
    {
      label: t('strategy.initiative_performance.labels.progress'),
      value: ThroughputMode.InitiativeProgress,
      leftSection: <Icon name="lightbulb" size={20} color={secondaryBase} />,
    },
  ];
  if (currentStrategyTab !== StrategyTab.Epics) {
    options.push({
      label: t('strategy.initiative_performance.labels.contributing_epics'),
      value: ThroughputMode.ContributingEpics,
      leftSection: <Icon name="move_down" size={20} color={secondaryBase} />,
    });
  }
  options.push({
    label: t('strategy.initiative_performance.labels.contributing_teams'),
    value: ThroughputMode.ContributingTeams,
    leftSection: <Icon name="people_alt" size={20} color={secondaryBase} />,
  });

  if (currentStrategyTab === StrategyTab.Outcomes || currentStrategyTab === StrategyTab.Goals) {
    options.push({
      label: t('strategy.initiative_performance.labels.contributing_initiatives'),
      value: ThroughputMode.ContributingInitiatives,
      leftSection: <Icon name="move_down" size={20} color={secondaryBase} />,
    });
  }
  if (currentStrategyTab === StrategyTab.Goals) {
    options.push({
      label: t('strategy.initiative_performance.labels.contributing_outcomes'),
      value: ThroughputMode.ContributingOutcomes,
      leftSection: <Icon name="ads_click" size={20} color={secondaryBase} />,
    });
  }

  return options;
};

export { getThroughputModeOptions };
